<script setup>
import { Splide, SplideSlide } from '@splidejs/vue-splide'

defineProps({
  sponsors: {
    type: Array,
    required: true
  }
})

const options = {
  rewind: true,
  perPage: 5,
  gap: '1rem',
  arrows: false,
  pagination: false,
  breakpoints: {
    640: {
      perPage: 2,
      gap: '0.5rem'
    }
  }
}
</script>

<template>
  <Splide :options="options" aria-label="Sponsor Images">
    <SplideSlide v-for="sponsor in sponsors">
      <img :src="sponsor?.logo_url" :alt="sponsor.name" class="rounded-full">
    </SplideSlide>
  </Splide>
</template>

<style scoped>

</style>
